import React from "react";
import { GraduationCap, TrendingUp, MessageCircle, Clock, Sparkles, Wallet } from "lucide-react";
import { ContentPage, Section, FeatureCard } from "../../components/ContentPage";

export default function Szkolenia() {
  return (
    <ContentPage
      testid="page-szkolenia"
      eyebrow="Szkolenia dla modelek"
      title={<>Naucz się <span className="text-coral">zarabiać więcej.</span></>}
      lead="Praktyczne szkolenia dla twórczyń 18+ — jak budować markę, prowadzić sprzedaż, rozmawiać z fanami i skalować przychody. Wiedza, którą wykorzystasz od pierwszego dnia."
      seo={{
        title: "Szkolenia dla modelek — jak zarabiać więcej | PMPOINT",
        description: "Praktyczne szkolenia dla twórczyń 18+: budowanie marki, sprzedaż, czatowanie, monetyzacja i skalowanie przychodów na OnlyFans, Fansly, MYM i innych platformach.",
        canonical: "https://pmpoint.pl/szkolenia",
      }}
    >
      <Section title="Czego się nauczysz">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <FeatureCard icon={Sparkles} title="Budowanie marki" text="Jak zbudować rozpoznawalny, sprzedażowy wizerunek — z twarzą lub anonimowo." />
          <FeatureCard icon={MessageCircle} title="Sztuka czatowania" text="Techniki rozmów, które budują relację z fanem i realnie zwiększają sprzedaż." />
          <FeatureCard icon={Wallet} title="Monetyzacja" text="Ceny, pakiety, up-selling i strategie, które zwiększają wartość każdego klienta." />
          <FeatureCard icon={TrendingUp} title="Skalowanie" text="Jak rosnąć na wielu platformach jednocześnie bez wypalenia." />
          <FeatureCard icon={Clock} title="Organizacja pracy" text="Planowanie treści i czasu tak, by pracować mądrzej, nie ciężej." />
          <FeatureCard icon={GraduationCap} title="Wsparcie mentora" text="Indywidualne wskazówki od zespołu, który robi to na co dzień." />
        </div>
      </Section>

      <Section title="Dla kogo są szkolenia">
        <div className="grid sm:grid-cols-3 gap-5">
          <FeatureCard title="Początkujące" text="Startujesz od zera i chcesz zrobić to dobrze od pierwszego dnia." />
          <FeatureCard title="Doświadczone" text="Masz już profil, ale czujesz, że możesz zarabiać znacznie więcej." />
          <FeatureCard title="Ambitne" text="Chcesz traktować to jak biznes i skalować przychody na poważnie." />
        </div>
      </Section>
    </ContentPage>
  );
}
